import * as React from 'react';
import { Component } from 'react';
import Alert from 'react-s-alert';

import $ from 'jquery';
import _ from 'lodash';

import { takeDir } from './utils.js';
import { get_lyrs_of } from './image_mix.js';

import App from './App.jsx';

import './css/TablaOportCuadro.css';

// Se usa el formato americano: separador de miles ',' y separador decimal '.'
require('numeral/locales/en-gb');
const numeral = require('numeral');

const
  logoMapa = require('./css/img/central_fert/img_mapa.png'),
  triangulo = require('./css/img/central_fert/triangulo.png')
;

type T_TablaOportCuadroProps = {
  app: App,
  culti: string,
  cultivo: string,
  elem: string,
  hect: number,
  is_diff: boolean,
  margen: string,
  png: string,
  recom: Array<object>,
  recom_lim: object,
  servicio: string,
  showPrecio: boolean,
  tif: string,
  title1: string,
  title2: string,
}

export default class TablaOportCuadro extends Component <T_TablaOportCuadroProps> {
  constructor(props: T_TablaOportCuadroProps) {
    super(props);

    this.state = {
      escalaTab: 'F1',
      images: {
        images_0: [],
        images_1: [],
        images_2: []
      },
      data: {
        total_pix: -1,
        perc_suboptimo: -1,
        q1_perc: -1,
        q2_perc: -1,
        q3_perc: -1,
        q2_hect: -1,
        q3_hect: -1,
        q4_hect: -1
      },
      recom_lim: {
        recom_min: -1,
        recom_max: -1,
        q3_lim: -1,
        q2_lim: -1
      },
      recom_escalas: []
    }
  }

  componentDidMount() {
    const
      { app, hect, culti, cultivo, is_diff, png, tif, elem_units, recom, servicio, parent } = this.props,
      escala_for = takeDir(culti) + '/' + png
    ;
    
    const
      images_0 = (recom[0].num).map((num, n) => require(`./css/img/tabla_oport/${cultivo}/${servicio}/${elem_units.elem}/img1-${n +1}.png`)),
      images_1 = (recom[1].num).map((num, n) => require(`./css/img/tabla_oport/${cultivo}/${servicio}/${elem_units.elem}/img2-${n +1}.png`)),
      images_2 = (recom[2].num).map((num, n) => require(`./css/img/tabla_oport/${cultivo}/${servicio}/${elem_units.elem}/img3-${n +1}.png`))
    ;

    const prePilotos = ['agave', 'banano', 'pina', 'cana'];

    this.setState({ images: {images_0, images_1, images_2} })

    const checkEscala = (escalaPNG, f) => escalaPNG.includes(f);

    if (is_diff) {
      const rangoBiosense = cultivo === 'pina' ? -5 : (cultivo === 'agave' ? -10 : -7.5);
      $.ajax({
        type: 'POST',
        url: `${app.remote}/write-tif-json-upl-diff/?session_id=${app.session()}`,
        dataType: 'json',
        async: true,
        data: {
          dir: takeDir(culti),
          tif: tif,
          elem: elem_units.elem,
          recom_lim: rangoBiosense
        }
      }).done(res => {
        // console.log(res);
        const url = `${app.remote}/get-deficit/?session_id=${app.session()}&dir=${takeDir(culti)}/${tif}.def.json`;
    
        fetch(url).then(resp => resp.json()).then(res => {
          const
            data = {
              bajo_perc:      (res.bajo * 100) / res.total,
              sobre_perc:     (res.sobre * 100) / res.total,
              bajo_hect:      (res.bajo * hect) / res.total,
              sobre_hect:     (res.sobre * hect) / res.total
            }
          ;
    
          this.setState({ data });
        })
      });
    } else if (!is_diff && servicio === 'nutricheck_foliar' && !prePilotos.includes(cultivo)) {
      let
        recom_lim_nutri = {},
        recom_escalas = []
      ;

      if (checkEscala(png, 'f1')) {
        recom_lim_nutri = {
          recom_min: recom[0].foliar[0],
          recom_mid: recom[0].foliar[1],
          recom_max: recom[0].foliar[2]
        };

        recom_escalas = [
          {
            num: [recom[0].num[0]],
            price: [recom[0].price[0]],
            unit: [recom[0].unit[0]]
          },
          {
            num: [recom[1].num[0]],
            price: [recom[1].price[0]],
            unit: [recom[1].unit[0]]
          },
          {
            num: [recom[2].num[0]],
            price: [recom[2].price[0]],
            unit: [recom[2].unit[0]]
          }
        ];
      } else if (checkEscala(png, 'f2')) {
        recom_lim_nutri = {
          recom_min: recom[1].foliar[0],
          recom_mid: recom[1].foliar[1],
          recom_max: recom[1].foliar[2]
        };

        recom_escalas = [
          {
            num: [recom[0].num[1]],
            price: [recom[0].price[1]],
            unit: [recom[0].unit[1]]
          },
          {
            num: [recom[1].num[1]],
            price: [recom[1].price[1]],
            unit: [recom[1].unit[1]]
          },
          {
            num: [recom[2].num[1]],
            price: [recom[2].price[1]],
            unit: [recom[2].unit[1]]
          }
        ];
      } else if (checkEscala(png, 'f3')) {
        recom_lim_nutri = {
          recom_min: recom[2].foliar[0],
          recom_mid: recom[2].foliar[1],
          recom_max: recom[2].foliar[2]  
        };

        recom_escalas = [
          {
            num: [recom[0].num[2]],
            price: [recom[0].price[2]],
            unit: [recom[0].unit[2]]
          },
          {
            num: [recom[1].num[2]],
            price: [recom[1].price[2]],
            unit: [recom[1].unit[2]]
          },
          {
            num: [recom[2].num[2]],
            price: [recom[2].price[2]],
            unit: [recom[2].unit[2]]
          }
        ];
      }
      
      this.setState({ recom_lim: recom_lim_nutri, recom_escalas }, () => {
        const
          { recom_escalas, recom_lim } = this.state,
          url_nutr_foliar = `${app.remote}/write-tif-json-upl-foliar/?session_id=${app.session()}`
        ;

          $.ajax({
            type: 'POST',
            url: url_nutr_foliar,
            dataType: 'json',
            async: true,
              data: {
                dir: takeDir(culti),
                tif: tif,
                elem: elem_units.elem,
                recom_min: recom_lim
              }
          }).done(res => {
            const url = `${app.remote}/get-deficit/?session_id=${app.session()}&dir=${takeDir(culti)}/${tif}.def.json`;

            fetch(url).then(resp => resp.json()).then(res => {
              const
                sum = res.mbajo + res.bajo + res.moderado,
                data = {
                  total_pix:      sum,                       // Cantidad total de pixeles
                  perc_suboptimo: (sum * 100) / res.total,
                  mbajo_perc:     (res.mbajo * 100) / res.total,
                  bajo_perc:      (res.bajo * 100) / res.total,
                  moderado_perc:  (res.moderado * 100) / res.total,
                  mbajo_hect:     (res.mbajo * hect) / res.total,
                  bajo_hect:      (res.bajo * hect) / res.total,
                  moderado_hect:  (res.moderado * hect) / res.total
            }
              ;

              this.setState({ data }, () => {
                const precioTotal = (recomList) => {
                  const recomModerado = recomList[0].num.map((num, n) => num * recomList[0].price[n] * data.moderado_hect);
                  const recomBajo = recomList[1].num.map((num, n) => num * recomList[1].price[n] * data.bajo_hect);
                  const recomMbajo = recomList[2].num.map((num, n) => num * recomList[2].price[n] * data.mbajo_hect);
            
                  return _.sum(recomModerado) + _.sum(recomBajo) + _.sum(recomMbajo);
                };

                parent.state.valorRecom[elem_units.elem] = precioTotal(recom_escalas);
              });
            });
          });
      });
    } else {
      get_lyrs_of(app, [escala_for], (lyrs: Array<?T_EscalaLyr>): void => {
        // console.log(lyrs);
        if (lyrs.length > 0 && lyrs[0] != null) {
          const
            { servicio } = this.props,
            elem_range = lyrs[0].elemRange,
            max_range = Math.max(...elem_range),
            min_range = Math.min(...elem_range),
            def_range_soil = (Math.max(...elem_range) - Math.min(...elem_range)) / 3,
            def_range = (Math.max(...elem_range) - Math.min(...elem_range)) / 2,
            def_max = Math.min(...elem_range) + def_range,
            recom_lim_nutri = {
              recom_min: def_max,
              q3_lim: (def_max / 3) * 2,
              q2_lim: def_max / 3
            },
            recom_lim_soil = {
              recom_min: elem_units.elem !== 'mo' ? min_range + def_range_soil: min_range,
              recom_max: elem_units.elem !== 'mo' ? min_range + (2 * def_range_soil) : max_range
            }
          ;

          this.setState({ recom_lim: (servicio !== 'soilcheck' ? recom_lim_nutri : recom_lim_soil) }, () => {
            const
              { servicio } = this.props,
              { recom_lim } = this.state,
              url_nutr = `${app.remote}/write-tif-json-upl/?session_id=${app.session()}`, 
              url_soil = `${app.remote}/write-tif-json-upl-soil/?session_id=${app.session()}`
            ;

            $.ajax({
              type: 'POST',
              url: servicio !== 'soilcheck' ? url_nutr : url_soil,
              dataType: 'json',
              async: true,
                data: {
                  dir: takeDir(culti),
                  tif: tif,
                  elem: elem_units.elem,
                  recom_min: servicio !== 'soilcheck' ? recom_lim.recom_min : recom_lim
                }
            }).done(res => {
              // console.log(res);
              const url = `${app.remote}/get-deficit/?session_id=${app.session()}&dir=${takeDir(culti)}/${tif}.def.json`;
          
              fetch(url).then(resp => resp.json()).then(res => {
                // console.log(res);
                if (servicio !== 'soilcheck') {
                  const
                    sum = res.mbajo + res.bajo + res.moderado,
                    data = {
                      total_pix:      sum,                       // Cantidad total de pixeles
                      perc_suboptimo: (sum * 100) / res.total,
                      mbajo_perc:     (res.mbajo * 100) / res.total,
                      bajo_perc:      (res.bajo * 100) / res.total,
                      moderado_perc:  (res.moderado * 100) / res.total,
                      mbajo_hect:     (res.mbajo * hect) / res.total,
                      bajo_hect:      (res.bajo * hect) / res.total,
                      moderado_hect:  (res.moderado * hect) / res.total
                    }
                  ;

                  this.setState({ data }, () => {
                    const precioTotal = (recomList) => {
                      const recomModerado = recomList[0].num.map((num, n) => num * recomList[0].price[n] * data.moderado_hect);
                      const recomBajo = recomList[1].num.map((num, n) => num * recomList[1].price[n] * data.bajo_hect);
                      const recomMbajo = recomList[2].num.map((num, n) => num * recomList[2].price[n] * data.mbajo_hect);
                
                      return _.sum(recomModerado) + _.sum(recomBajo) + _.sum(recomMbajo);
                    };

                    parent.state.valorRecom[elem_units.elem] = precioTotal(recom);
                  });
              } else {
                  const
                    data = {
                      total_pix: res.total,
                      bajo_perc: (res.bajo * 100) / res.total,
                      entre_perc: (res.entre * 100) / res.total,
                      sobre_perc: (res.sobre * 100) / res.total,
                      bajo_hect: (res.bajo * hect) / res.total,
                      entre_hect: (res.entre * hect) / res.total,
                      sobre_hect: (res.sobre * hect) / res.total
                    }
                  ;

                  this.setState({ data });
                }
              })
            });
          });
        } else {
          Alert.error('No pude encontrar los límites de la escala.');
        }
      });
    }
  }

  render_cuadro() {
    numeral.locale('en-gb');
    
    const
      { elem_units, title1, title2, margen, recom, showPrecio } = this.props,
      { images, data, recom_lim } = this.state,
      color_total = [],
      total_hect_def = data.mbajo_hect + data.bajo_hect + data.moderado_hect
    ;
      
    if (data.perc_suboptimo < 50) {
      color_total.push('#efd144');
    } else if (data.perc_suboptimo >= 50 && data.perc_suboptimo <= 75) {
      color_total.push('#d68932');
    } else if (data.perc_suboptimo > 75 && data.perc_suboptimo <= 100) {
      color_total.push('#c5442e');
    }

    const precioTotal = (recomList) => {
      const recomModerado = recomList[0].num.map((num, n) => Math.ceil(num * recomList[0].price[n] * data.moderado_hect));
      const recomBajo = recomList[1].num.map((num, n) => Math.ceil(num * recomList[1].price[n] * data.bajo_hect));
      const recomMbajo = recomList[2].num.map((num, n) => Math.ceil(num * recomList[2].price[n] * data.mbajo_hect));

      return _.sum(recomModerado) + _.sum(recomBajo) + _.sum(recomMbajo);
    };

    return (
      <div className="CuadroOpt" style={{ margin: '15px auto' }}>
        <div className="TitleCuadroOpt"><span className="Title1CuadropOpt"><strong>{title1}</strong></span><span className="Title2CuadroOpt"><strong> {title2}</strong></span></div>
        <div className="ContentOpt">
          <div className="defTotal">
            <p style={{ marginBottom: '10px' }}>{margen}</p>
            <div className= "greyVerticalBar" style={{ height: '80px', width: '20px', borderRadius: '10px' }}>
              <div className="colorBar" style={{ backgroundColor: color_total[0], height: `${data.perc_suboptimo}%`, top: `${100 - data.perc_suboptimo}%` }}/>
            </div>
            <div style={{ fontSize: '24px' }}>
              <p style={{ margin: '5px auto 0px auto' }}>{numeral(data.perc_suboptimo).format('0,0')}%</p>
            </div>
            <div><p>DEL CULTIVABLE</p></div>
            <div className="defMax">
              <p className="defMaxValue"><img src={triangulo} alt="triangulo" className="defMaxTriangle" />{numeral(recom_lim.recom_min).format('0,0.0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold', fontSize: '13px' }}>{elem_units.unit}</span></p>
              <p style={{ fontSize: '13px', marginTop: '5px' }}>UMBRAL DE DEFICIENCIA</p>
            </div>
          </div>
          <div className="RecomOpt">
            <div className="HectOpt" style={{ paddingBottom: '0px' }}>
              <span><p>Superficie deficitaria</p></span>
              <div style={{ backgroundColor: '#ffffff', padding: '0px' }}>
                <img src={logoMapa} className="img-mapaUPL" alt="logo_mapa" />
                <span style={{ position: 'relative', fontFamily: 'BebasNeue', fontSize: '30px', top: '5px' }}> {numeral(total_hect_def).format('0,0.0')} </span><span style={{ position: 'relative', fontFamily: 'Raleway', top: '5px' }}><strong> has</strong></span>
              </div>
            </div>
            <div className="defHect" style={{ display: 'block', margin: '0px', backgroundColor: '#e2e2e2' }}>
              <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Superficie por grado de deficiencia</p></span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="defHectRange right" style={{ margin: '10px 0px' }}>
                  <div className="greybar">
                    <div className="yellowBar" style={{ width: `${Math.ceil(data.moderado_perc)}%`, backgroundColor: '#efd144' }}/>
                  </div>
                  <span style={{ fontSize: '24px' }}>{numeral(data.moderado_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#efd144', fontSize: '20px'}}><strong> has</strong></span>
                  <div className="HectRangeBottom"/>
                  <div className="defHectLim">
                    <span>{numeral(recom_lim.recom_min).format('0,0.0')} - {numeral(recom_lim.q3_lim).format('0,0.0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                  </div>
                </div>
                <div className="defHectRange right" style={{ margin: '10px 0px' }}>
                  <div className="greybar">
                    <div className="orangeBar" style={{ width: `${Math.ceil(data.bajo_perc)}%`, backgroundColor: '#d68932' }}/>
                  </div>
                  <span style={{ fontSize: '24px' }}>{numeral(data.bajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#d68932', fontSize: '20px'}}><strong> has</strong></span>
                  <div className="HectRangeBottom"/>
                  <div className="defHectLim">
                    <span>{numeral(recom_lim.q3_lim).format('0,0.0')} - {numeral(recom_lim.q2_lim).format('0,0.0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                  </div>
                </div>
                <div className="defHectRange" style={{ margin: '10px 0px' }}>
                  <div className="greybar">
                    <div className="redBar" style={{ width: `${Math.ceil(data.mbajo_perc)}%`, backgroundColor: '#c5442e' }}/>
                  </div>
                  <span style={{ fontSize: '24px' }}>{numeral(data.mbajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#c5442e', fontSize: '20px'}}><strong> has</strong></span>
                  <div className="HectRangeBottom"/>
                  <div className="defHectLim">
                  <span>&lt; {numeral(recom_lim.q2_lim).format('0,0.0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="RecomProd" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
              <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Productos recomendados</p></span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="recomUnitProd right" style={{ margin: '10px 0px' }}>
                  {(recom[0].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_0[n]} alt="img1" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[0].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
                <div className="recomUnitProd right">
                  {(recom[1].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_1[n]} alt="img2" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[1].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
                <div className="recomUnitProd">
                  {(recom[2].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_2[n]} alt="img3" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[2].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="RecomHect" style={{ display: 'block', backgroundColor: '#e2e2e2'}}>
              <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Total</p></span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="recomHectProd right" style={{ margin: '10px 0px' }}>
                  {(recom[0].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.moderado_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom[0].unit[n]}</span></p>
                    </div>
                  )}
                </div>
                <div className="recomHectProd right" style={{ margin: '10px 0px' }}>
                  {(recom[1].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom[1].unit[n]}</span></p>
                    </div>
                  )}
                </div>
                <div className="recomHectProd" style={{ margin: '10px 0px' }}>
                  {(recom[2].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.mbajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom[2].unit[n]}</span></p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {showPrecio &&
              <div className="RecomPrice" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
                <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Valor Subtotal</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomPriceProd right" style={{ margin: '10px 0px' }}>
                    {(recom[0].price).map((price, p) =>
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[0].num[p] * data.moderado_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                  <div className="recomPriceProd right" style={{ margin: '10px 0px' }}>
                    {(recom[1].price).map((price, p) => 
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[1].num[p] * data.bajo_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                  <div className="recomPriceProd" style={{ margin: '10px 0px' }}>
                    {(recom[2].price).map((price, p) =>
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[2].num[p] * data.mbajo_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
            {showPrecio &&
              <div className="RecomPrice" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
                <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Valor Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomPriceProd" style={{ margin: '10px 0px', width: '100%' }}>
                    <div className="recomPriceValue">
                      <p>$ {numeral(Math.ceil(precioTotal(recom))).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  render_cuadro_escalas() {
    numeral.locale('en-gb');
    
    const
      { elem_units, title1, title2, margen, recom, showPrecio } = this.props,
      { images, data, recom_escalas, recom_lim } = this.state,
      color_total = [],
      total_hect_def = data.mbajo_hect + data.bajo_hect + data.moderado_hect
    ;

    if (data.perc_suboptimo < 50) {
      color_total.push('#efd144');
    } else if (data.perc_suboptimo >= 50 && data.perc_suboptimo <= 75) {
      color_total.push('#d68932');
    } else if (data.perc_suboptimo > 75 && data.perc_suboptimo <= 100) {
      color_total.push('#c5442e');
    }

    const precioTotal = (recomList) => {
      const recomModerado = recomList[0].num.map((num, n) => Math.ceil(num * recomList[0].price[n] * data.moderado_hect));
      const recomBajo = recomList[1].num.map((num, n) => Math.ceil(num * recomList[1].price[n] * data.bajo_hect));
      const recomMbajo = recomList[2].num.map((num, n) => Math.ceil(num * recomList[2].price[n] * data.mbajo_hect));

      return _.sum(recomModerado) + _.sum(recomBajo) + _.sum(recomMbajo);
    };

    if (recom_escalas.length > 0) {
      return (
        <div className="CuadroOpt" style={{ margin: '15px auto' }}>
          <div className="TitleCuadroOpt"><span className="Title1CuadropOpt"><strong>{title1}</strong></span><span className="Title2CuadroOpt"><strong> {title2}</strong></span></div>
          <div className="ContentOpt">
            <div className="defTotal">
              <p style={{ marginBottom: '10px' }}>{margen}</p>
              <div className= "greyVerticalBar" style={{ height: '80px', width: '20px', borderRadius: '10px' }}>
                <div className="colorBar" style={{ backgroundColor: color_total[0], height: `${data.perc_suboptimo}%`, top: `${100 - data.perc_suboptimo}%` }}/>
              </div>
              <div style={{ fontSize: '24px' }}>
                <p style={{ margin: '5px auto 0px auto' }}>{numeral(data.perc_suboptimo).format('0,0')}%</p>
              </div>
              <div><p>DEL CULTIVABLE</p></div>
              <div className="defMax">
                <p className="defMaxValue"><img src={triangulo} alt="triangulo" className="defMaxTriangle" />{numeral(recom_lim.recom_max).format('0,0.0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold', fontSize: '13px' }}>{elem_units.unit}</span></p>
                <p style={{ fontSize: '13px', marginTop: '5px' }}>UMBRAL DE DEFICIENCIA</p>
              </div>
            </div>
            <div className="RecomOpt">
              <div className="HectOpt" style={{ paddingBottom: '0px' }}>
                <span><p>Superficie deficitaria</p></span>
                <div style={{ backgroundColor: '#ffffff', padding: '0px' }}>
                  <img src={logoMapa} className="img-mapaUPL" alt="logo_mapa" />
                  <span style={{ position: 'relative', fontFamily: 'BebasNeue', fontSize: '30px', top: '5px' }}> {numeral(total_hect_def).format('0,0.0')} </span><span style={{ position: 'relative', fontFamily: 'Raleway', top: '5px' }}><strong> has</strong></span>
                </div>
              </div>
              <div className="defHect" style={{ display: 'block', margin: '0px', backgroundColor: '#e2e2e2' }}>
                <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Superficie por grado de deficiencia</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="defHectRange right" style={{ margin: '10px 0px' }}>
                    <div className="greybar">
                      <div className="yellowBar" style={{ width: `${Math.ceil(data.moderado_perc)}%`, backgroundColor: '#efd144' }}/>
                    </div>
                    <span style={{ fontSize: '24px' }}>{numeral(data.moderado_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#efd144', fontSize: '20px'}}><strong> has</strong></span>
                    <div className="HectRangeBottom"/>
                    <div className="defHectLim">
                      <span>{numeral(recom_lim.recom_max).format('0,0.00')} - {numeral(recom_lim.recom_mid).format('0,0.00')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                    </div>
                  </div>
                  <div className="defHectRange right" style={{ margin: '10px 0px' }}>
                    <div className="greybar">
                      <div className="orangeBar" style={{ width: `${Math.ceil(data.bajo_perc)}%`, backgroundColor: '#d68932' }}/>
                    </div>
                    <span style={{ fontSize: '24px' }}>{numeral(data.bajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#d68932', fontSize: '20px'}}><strong> has</strong></span>
                    <div className="HectRangeBottom"/>
                    <div className="defHectLim">
                      <span>{numeral(recom_lim.recom_mid).format('0,0.00')} - {numeral(recom_lim.recom_min).format('0,0.00')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                    </div>
                  </div>
                  <div className="defHectRange" style={{ margin: '10px 0px' }}>
                    <div className="greybar">
                      <div className="redBar" style={{ width: `${Math.ceil(data.mbajo_perc)}%`, backgroundColor: '#c5442e' }}/>
                    </div>
                    <span style={{ fontSize: '24px' }}>{numeral(data.mbajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#c5442e', fontSize: '20px'}}><strong> has</strong></span>
                    <div className="HectRangeBottom"/>
                    <div className="defHectLim">
                    <span>&lt; {numeral(recom_lim.recom_min).format('0,0.00')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{elem_units.unit}</span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="RecomProd" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
                <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Productos recomendados</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomUnitProd right" style={{ margin: '10px 0px' }}>
                    {(recom_escalas[0].num).map((num, n) => 
                      <div key={n}>
                        <img src={images.images_0[n]} alt="img1" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom_escalas[0].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                  <div className="recomUnitProd right">
                    {(recom_escalas[1].num).map((num, n) => 
                      <div key={n}>
                        <img src={images.images_1[n]} alt="img2" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom_escalas[1].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                  <div className="recomUnitProd">
                    {(recom_escalas[2].num).map((num, n) => 
                      <div key={n}>
                        <img src={images.images_2[n]} alt="img3" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom_escalas[2].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="RecomHect" style={{ display: 'block', backgroundColor: '#e2e2e2'}}>
                <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomHectProd right" style={{ margin: '10px 0px' }}>
                    {(recom_escalas[0].num).map((num, n) => 
                      <div key={n} className="recomHectValue">
                        <p>{numeral(Math.ceil(num * data.moderado_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom_escalas[0].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                  <div className="recomHectProd right" style={{ margin: '10px 0px' }}>
                    {(recom_escalas[1].num).map((num, n) => 
                      <div key={n} className="recomHectValue">
                        <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom_escalas[1].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                  <div className="recomHectProd" style={{ margin: '10px 0px' }}>
                    {(recom_escalas[2].num).map((num, n) => 
                      <div key={n} className="recomHectValue">
                        <p>{numeral(Math.ceil(num * data.mbajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}>{recom_escalas[2].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {showPrecio &&
                <div className="RecomPrice" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
                  <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Valor Subtotal</p></span>
                  <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                    <div className="recomPriceProd right" style={{ margin: '10px 0px' }}>
                      {(recom_escalas[0].price).map((price, p) =>
                        <div key={p} className="recomPriceValue">
                          <p>$ {numeral(Math.ceil(price * recom_escalas[0].num[p] * data.moderado_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                    <div className="recomPriceProd right" style={{ margin: '10px 0px' }}>
                      {(recom_escalas[1].price).map((price, p) => 
                        <div key={p} className="recomPriceValue">
                          <p>$ {numeral(Math.ceil(price * recom_escalas[1].num[p] * data.bajo_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                    <div className="recomPriceProd" style={{ margin: '10px 0px' }}>
                      {(recom_escalas[2].price).map((price, p) =>
                        <div key={p} className="recomPriceValue">
                          <p>$ {numeral(Math.ceil(price * recom_escalas[2].num[p] * data.mbajo_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              }
              {showPrecio &&
                <div className="RecomPrice" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
                  <span style={{ display: 'inline-block', height: '35px', padding: '5px 0px', fontFamily: 'OpenSans', fontSize: '15px', fontWeight: '600' }}><p style={{ margin: '0px' }}>Valor Total</p></span>
                  <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                    <div className="recomPriceProd" style={{ margin: '10px 0px', width: '100%' }}>
                      <div className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(precioTotal(recom_escalas))).format('0,0')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      )      
    }
  }

  render_cuadro_soil() {
    numeral.locale('en-gb');
    
    const
      { elem_units, title1, title2, recom, showPrecio } = this.props,
      { images, data, recom_lim } = this.state
    ;

    const precioTotal = (recomList) => {
      const recomAlto  = recomList[2].num.map((num, n) => Math.ceil(num * recomList[2].price[n] * data.sobre_hect));
      const recomEntre = recomList[1].num.map((num, n) => Math.ceil(num * recomList[1].price[n] * data.entre_hect));
      const recomBajo  = recomList[0].num.map((num, n) => Math.ceil(num * recomList[0].price[n] * data.bajo_hect));

      return _.sum(recomAlto) + _.sum(recomEntre) + _.sum(recomBajo);
    };

    return (
      <div className="CuadroOpt" style={{ margin: '15px auto' }}>
        <div className="TitleCuadroOpt"><span className="Title1CuadropOpt"><strong>{title1}</strong></span><span className="Title2CuadroOpt"><strong> {title2}</strong></span></div>
        <div className="ContentOpt">
          <div className="RecomOpt soilBorder">
            <div className="HectOpt">
              <span><p style={{ margin: '0px', fontSize: '14px' }}>{elem_units.elem !== 'mo' ? 'Superficie según disponibilidad' : 'Superficie según contenido'}</p></span>
            </div>
            <div className="defHect" style={{ margin: '10px 0px 5px 0px'}}>
              <div className="defHectRange soilCheck right"  style={{ width: '135px' }}>
                <div className="greybar">
                  <div className="redBar" style={{ width: `${Math.ceil(data.sobre_perc)}%`, backgroundColor: elem_units.elem !== 'mo' ? '#015076' : '#795c1a' }}/>
                </div>
                <span style={{ fontSize: '24px' }}>{numeral(data.sobre_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway', fontSize: '16px'}}><strong> has</strong></span>
                <div><p style={{ margin: '0px', fontSize: '16px', color: elem_units.elem !== 'mo' ? '#015076' : '#795c1a' }}>{elem_units.elem !== 'mo' ? 'MAYOR RETENCIÓN': 'ALTO CONTENIDO'}</p></div>
                <div className="HectRangeBottom"/>
                <div className="defHectLim">
                <span>{`> ${numeral(recom_lim.recom_max).format('0,0.0')}`}<span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}> {elem_units.unit}</span></span>
                </div>
              </div>
              <div className="defHectRange soilCheck right" style={{ width: '160px' }}>
                <div className="greybar">
                  <div className="orangeBar" style={{ width: `${Math.ceil(data.entre_perc)}%`, backgroundColor: elem_units.elem !== 'mo' ? '#248da9' : '#b58d11' }}/>
                </div>
                <span style={{ fontSize: '24px' }}>{numeral(data.entre_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway', fontSize: '16px'}}><strong> has</strong></span>
                <div><p style={{ margin: '0px', fontSize: '16px', color: elem_units.elem !== 'mo' ? '#248da9' : '#b58d11' }}>{elem_units.elem !== 'mo' ? 'RETENCIÓN INTERMEDIA': 'CONTENIDO INTERMEDIO'}</p></div>
                <div className="HectRangeBottom"/>
                <div className="defHectLim">
                  <span>{`${numeral(recom_lim.recom_max).format('0,0.0')} - ${numeral(recom_lim.recom_min).format('0,0.0')}`}<span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}> {elem_units.unit}</span></span>
                </div>
              </div>
              <div className="defHectRange soilCheck" style={{ width: '135px' }}>
                <div className="greybar">
                  <div className="yellowBar" style={{ width: `${Math.ceil(data.bajo_perc)}%`, backgroundColor: elem_units.elem !== 'mo' ? '#bddbe0' : '#edd36c'}}/>
                </div>
                <span style={{ fontSize: '24px' }}>{numeral(data.bajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway', fontSize: '16px'}}><strong> has</strong></span>
                <div><p style={{ margin: '0px', fontSize: '16px', color: elem_units.elem !== 'mo' ? '#bddbe0' : '#edd36c' }}>{elem_units.elem !== 'mo' ? 'MENOR RETENCIÓN': 'BAJO CONTENIDO'}</p></div>
                <div className="HectRangeBottom"/>
                <div className="defHectLim">
                  <span>{`< ${numeral(recom_lim.recom_min).format('0,0.0')}`}<span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}> {elem_units.unit}</span></span>
                </div>
              </div>
            </div>
            <div className="RecomProd" style={{ display: 'block' }}>
              <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{  margin: '0px' }}>Productos recomendados</p></span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="recomUnitProd soilCheck right" style={{ width: '135px' }}>
                  {(recom[2].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_2[n]} alt="img3" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[2].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
                <div className="recomUnitProd soilCheck right" style={{ width: '160px' }}>
                  {(recom[1].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_1[n]} alt="img2" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[1].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
                <div className="recomUnitProd soilCheck" style={{ width: '135px' }}>
                  {(recom[0].num).map((num, n) => 
                    <div key={n}>
                      <img src={images.images_0[n]} alt="img1" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[0].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
              </div>
            </div> 
            <div className="RecomHect" style={{ display: 'block' }}>
              <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{  margin: '0px' }}>Total</p></span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="recomHectProd soilCheck right" style={{ width: '135px' }}>
                  {(recom[2].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.sobre_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[2].unit[n]}</span></p>
                    </div>
                  )}
                </div>
                <div className="recomHectProd soilCheck right" style={{ width: '160px' }}>
                  {(recom[1].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.entre_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[1].unit[n]}</span></p>
                    </div>
                  )}
                </div>
                <div className="recomHectProd soilCheck" style={{ width: '135px' }}>
                  {(recom[0].num).map((num, n) => 
                    <div key={n} className="recomHectValue">
                      <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[0].unit[n]}</span></p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {showPrecio && recom[2].price.length !== 0 &&
              <div className="RecomPrice" style={{ display: 'block' }}>
                <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{ margin: '0px' }}>Valor Subtotal</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomPriceProd soilCheck right" style={{ width: '135px' }}>
                    {(recom[2].price).map((price, p) => 
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[2].num[p] * data.sobre_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                  <div className="recomPriceProd soilCheck right" style={{ width: '160px' }}>
                    {(recom[1].price).map((price, p) => 
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[1].num[p] * data.entre_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                  <div className="recomPriceProd soilCheck" style={{ width: '135px' }}>
                    {(recom[0].price).map((price, p) => 
                      <div key={p} className="recomPriceValue">
                        <p>$ {numeral(Math.ceil(price * recom[0].num[p] * data.bajo_hect)).format('0,0')}</p>
                      </div>  
                    )}
                  </div>
                </div>
              </div>
            }
            {showPrecio && recom[2].price.length !== 0 &&
              <div className="RecomPriceTotal" style={{ display: 'block' }}>
                <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{ margin: '0px' }}>Valor Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div className="recomPriceTotal soilCheck" style={{ width: '100%'}}>
                    <div className="recomPriceTotalValue">
                      <p>$ {numeral(Math.ceil(precioTotal(recom))).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  changeEscala = ev => {
    this.setState({ escalaTab: ev.target.dataset.tab });
  }

  render_cuadro_diff_escalas() {
    numeral.locale('en-gb');
    
    const
      { cultivo, elem_units, title1, title2, recom, showPrecio } = this.props,
      { escalaTab, images, data } = this.state
    ;

    let rangoBiosense = 0;

    if (
      cultivo === 'pina'     ||
      cultivo === 'tomate'   ||
      cultivo === 'pepino'   ||
      cultivo === 'pimiento'
    ) {
        rangoBiosense = 5;
    }
    else if (
      cultivo === 'agave'   ||
      cultivo === 'fresa'   ||
      cultivo === 'manzano' ||
      cultivo === 'nogal'   ||
      cultivo === 'aguacate'
    ) {
      rangoBiosense = 10;
    }
    else if (
      cultivo === 'banano' ||
      cultivo === 'cana'
    ) {
      rangoBiosense = 7.5;
    } else if (
      cultivo === 'papa'
    ) {
      rangoBiosense = 7;
    }

    const precioTotalEscala = (recomList, escala) => {
      if (escala === 'F1') {
        const recomEntre = recomList[0].num.map((num, n) => Math.ceil(num * recom[0].price[n] * data.bajo_hect));
        return _.sum(recomEntre);
      } else if (escala === 'F2') {
        const recomEntre = recomList[1].num.map((num, n) => Math.ceil(num * recom[1].price[n] * data.bajo_hect));
        return _.sum(recomEntre);
      } else if (escala === 'F3') {
        const recomEntre = recomList[2].num.map((num, n) => Math.ceil(num * recom[2].price[n] * data.bajo_hect));
        return _.sum(recomEntre);
      }
    };

    return (
      <div className="CuadroOpt" style={{ margin: '15px auto' }}>
        <div className="TitleCuadroOpt"><span className="Title1CuadropOpt"><strong>{title1}</strong></span></div>
        <div className="ContentOpt" style={{ display: 'block' }}>
          <div style={{ display: 'flex' }}>
            <div className="defTotal" style={{ width: '200px', padding: '20px 10px' }}>
              <p style={{ marginBottom: '10px' }}>{title2}</p>
              <div className="greyVerticalBar" style={{ height: '80px', width: '20px', borderRadius: '10px' }}>
                <div className="colorBar" style={{ backgroundColor: '#c5442e', height: `${data.bajo_perc}%`, top: `${100 - data.bajo_perc}%` }}/>
              </div>
              <div style={{ fontSize: '24px' }}>
                <p style={{ margin: '5px auto 0px auto' }}>{numeral(data.bajo_perc).format('0,0')}%</p>
              </div>
              <div><p>DEL CULTIVABLE</p></div>
              <div className="defMax">
                <p className="defMaxValue"><img src={triangulo} alt="triangulo" className="defMaxTriangle" />{numeral(rangoBiosense).format('0,0.0')} {elem_units.unit}</p>
                <p style={{ fontSize: '13px', marginTop: '5px' }}>UMBRAL DE DISMINUCIÓN</p>
              </div>
            </div>
            <div>
              <div className="HectOpt" style={{ margin: '0px', fontFamily: 'OpenSans' }}>
                <span>
                  <p style={{ margin: '0px' }}>Superficie según disminución</p>
                  <p style={{ position: 'relative', bottom: '6px', margin: '0px' }}>porcentual de biomasa</p>
                </span>
              </div>
              <div className="defHect" style={{ borderLeft: '1px solid #e2e2e2', fontSize: '45px', margin: '0px' }}>
                <div className="defHectRange" style={{ margin: '71px auto', padding: '0px 60px', minWidth: '400px' }}>
                  <div className="greybar" style={{ margin: '0px 50px 10px', height: '10px' }}>
                    <div className="redBar" style={{ height: '10px', width: `${Math.ceil(data.bajo_perc)}%`, backgroundColor: '#c5442e' }}/>
                  </div>
                  <span>{numeral(data.bajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#c5442e', fontSize: '30px'}}><strong> has</strong></span>
                  <div className="HectRangeBottom" style={{ height: '0px', width: '50%', borderBottom: '2px solid lightgrey'}}/>
                  <div className="defHectLim" style={{ fontSize: '25px' }}>
                    <span>{`> ${numeral(rangoBiosense).format('0,0.0')}`}<span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}> {elem_units.unit}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="RecomOpt">
            <div className="RecomProd" style={{ display: 'block' }}>
              <span style={{ height: '36px', display: 'inline-block', padding: '7px 0px', fontWeight: '600' }}><p style={{ margin: '0px', fontFamily: 'OpenSans' }}>Producto Recomendado</p></span>
              <div className="RecomEscala">
                <div className="recomEscalaTab" data-tab={'F1'} style={{ backgroundColor: escalaTab === 'F1' ? '#429d00' : '#e2e2e2', color: escalaTab === 'F1' ? '#ffffff' : '#333333' }} onClick={this.changeEscala}>F 1</div>
                <div className="recomEscalaTab" data-tab={'F2'} style={{ backgroundColor: escalaTab === 'F2' ? '#429d00' : '#e2e2e2', color: escalaTab === 'F2' ? '#ffffff' : '#333333' }} onClick={this.changeEscala}>F 2</div>
                <div className="recomEscalaTab" data-tab={'F3'} style={{ backgroundColor: escalaTab === 'F3' ? '#429d00' : '#e2e2e2', color: escalaTab === 'F3' ? '#ffffff' : '#333333' }} onClick={this.changeEscala}>F 3</div>
              </div>
              <div style={{ backgroundColor: '#ffffff', minWidth: '300px' }}>
                {escalaTab === 'F1' &&
                  <div style={{ display: 'flex', padding: '0px 5px' }}>
                    {(recom[0].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <img src={images.images_0[n]} alt="img2" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom[0].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                }
                {escalaTab === 'F2' &&
                  <div style={{ display: 'flex', padding: '0px 5px' }}>
                    {(recom[1].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <img src={images.images_1[n]} alt="img2" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom[1].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                }
                {escalaTab === 'F3' &&
                  <div style={{ display: 'flex', padding: '0px 5px' }}>
                    {(recom[2].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <img src={images.images_2[n]} alt="img2" className="img-producto"/>
                        <p>{num} <strong className="recomStyle">{recom[2].unit[n]}/ha</strong></p>
                      </div>
                    )}
                  </div>
                }
              </div>
            </div> 
            <div className="RecomHect" style={{ display: 'block' }}>
              <span style={{ height: '37px', display: 'inline-block', padding: '7px 0px', fontFamily: 'OpenSans', fontWeight: '600' }}><p style={{ margin: '0px' }}>Total</p></span>
              <div style={{ backgroundColor: '#ffffff' }}>
                {escalaTab === 'F1' &&
                  <div style={{ display: 'flex' }}>
                    {(recom[0].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[0].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                }
                {escalaTab === 'F2' &&
                  <div style={{ display: 'flex' }}>
                    {(recom[1].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[1].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                }
                {escalaTab === 'F3' &&
                  <div style={{ display: 'flex' }}>
                    {(recom[2].num).map((num, n) => 
                      <div key={n} style={{ margin: '10px auto' }}>
                        <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[2].unit[n]}</span></p>
                      </div>
                    )}
                  </div>
                }
              </div>
            </div>
            {showPrecio &&
              <div className="RecomPrice" style={{ display: 'block' }}>
                <span style={{ height: '40px', display: 'inline-block', padding: '7px 0px', fontFamily: 'OpenSans', fontWeight: '600', fontSize: '14px' }}><p style={{ marginBottom: '10px' }}>Valor Subtotal</p></span>
                <div style={{ backgroundColor: '#ffffff'}}>
                  {escalaTab === 'F1' &&
                    <div style={{ display: 'flex' }}>
                      {(recom[0].price).map((price, p) => 
                        <div key={p} style={{ margin: '10px auto' }}>
                          <p>$ {numeral(Math.ceil(price * recom[0].num[p] * data.bajo_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                  }
                  {escalaTab === 'F2' &&
                    <div style={{ display: 'flex' }}>
                      {(recom[1].price).map((price, p) => 
                        <div key={p} style={{ margin: '10px auto' }}>
                          <p>$ {numeral(Math.ceil(price * recom[1].num[p] * data.bajo_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                  }
                  {escalaTab === 'F3' &&
                    <div style={{ display: 'flex' }}>
                      {(recom[2].price).map((price, p) => 
                        <div key={p} style={{ margin: '10px auto' }}>
                          <p>$ {numeral(Math.ceil(price * recom[2].num[p] * data.bajo_hect)).format('0,0')}</p>
                        </div>
                      )}
                    </div>
                  }
                </div>
              </div>
            }
            {showPrecio &&
              <div className="RecomPriceTotal" style={{ display: 'block' }}>
                <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{ marginBottom: '10px' }}>Valor Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div style={{ width: '100%'}}>
                    <div>
                      <p>$ {numeral(Math.ceil(precioTotalEscala(recom, escalaTab))).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  render_cuadro_diff() {
    numeral.locale('en-gb');
    
    const
      { cultivo, elem_units, title1, title2, recom, showPrecio } = this.props,
      { images, data } = this.state,
      rangoBiosense = cultivo === 'pina' ? 5 : (cultivo === 'agave' ? 10 : 7.5)
    ;

    const precioTotal = (recomList) => {
      const recomEntre = recomList[1].num.map((num, n) => Math.ceil(num * recomList[1].price[n] * data.bajo_hect));

      return _.sum(recomEntre);
    };
    
    return (
      <div className="CuadroOpt" style={{ margin: '15px auto' }}>
        <div className="TitleCuadroOpt"><span className="Title1CuadropOpt"><strong>{title1}</strong></span></div>
        <div className="ContentOpt">
          <div className="defTotal" style={{ width: '120px' }}>
            <p style={{ marginBottom: '10px' }}>{title2}</p>
            <div className="greyVerticalBar" style={{ height: '80px', width: '20px', borderRadius: '10px' }}>
              <div className="colorBar" style={{ backgroundColor: '#c5442e', height: `${data.bajo_perc}%`, top: `${100 - data.bajo_perc}%` }}/>
            </div>
            <div style={{ fontSize: '24px' }}>
              <p style={{ margin: '5px auto 0px auto' }}>{numeral(data.bajo_perc).format('0,0')}%</p>
            </div>
            <div><p>DEL CULTIVABLE</p></div>
            <div className="defMax">
              <p className="defMaxValue"><img src={triangulo} alt="triangulo" className="defMaxTriangle" />{numeral(rangoBiosense).format('0,0.0')} {elem_units.unit}</p>
              <p style={{ fontSize: '13px', marginTop: '5px' }}>UMBRAL DE DISMINUCIÓN</p>
            </div>
          </div>
          <div className="RecomOpt">
            <div className="HectOpt" style={{ margin: '0px', fontFamily: 'OpenSans' }}>
              <span>
                <p style={{ margin: '0px' }}>Superficie según disminución</p>
                <p style={{ position: 'relative', bottom: '6px', margin: '0px' }}>porcentual de biomasa</p>
              </span>
            </div>
            <div className="defHect">
              <div className="defHectRange" style={{ margin: '5px auto', padding: '0px 60px', minWidth: '300px' }}>
                <div className="greybar" style={{ margin: '0px 20px 10px 20px' }}>
                  <div className="redBar" style={{ width: `${Math.ceil(data.bajo_perc)}%`, backgroundColor: '#c5442e' }}/>
                </div>
                <span>{numeral(data.bajo_hect).format('0,0.0')}</span><span style={{ fontFamily: 'Raleway' , color: '#c5442e', fontSize: '16px'}}><strong> has</strong></span>
                <div className="HectRangeBottom"/>
                <div className="defHectLim">
                  <span>{`> ${numeral(rangoBiosense).format('0,0.0')}`}<span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}> {elem_units.unit}</span></span>
                </div>
              </div>
            </div>
            <div className="RecomProd" style={{ display: 'block' }}>
              <span style={{ height: '40px', display: 'inline-block', padding: '7px 0px', fontWeight: '600' }}><p style={{ margin: '0px', fontFamily: 'OpenSans' }}>Producto Recomendado</p></span>
              <div style={{ backgroundColor: '#ffffff', minWidth: '300px' }}>
                <div style={{ display: 'flex', padding: '0px 5px' }}>
                  {(recom[1].num).map((num, n) => 
                    <div key={n} style={{ margin: '10px auto' }}>
                      <img src={images.images_1[n]} alt="img2" className="img-producto"/>
                      <p>{num} <strong className="recomStyle">{recom[1].unit[n]}/ha</strong></p>
                    </div>
                  )}
                </div>
              </div>
            </div> 
            <div className="RecomHect" style={{ display: 'block' }}>
              <span style={{ height: '40px', display: 'inline-block', padding: '7px 0px', fontFamily: 'OpenSans', fontWeight: '600' }}><p style={{ margin: '0px' }}>Total</p></span>
              <div style={{ backgroundColor: '#ffffff' }}>
                <div style={{ display: 'flex' }}>
                  {(recom[1].num).map((num, n) => 
                    <div key={n} style={{ margin: '10px auto' }}>
                      <p>{numeral(Math.ceil(num * data.bajo_hect)).format('0,0')} <span style={{ fontFamily: 'GillSans', fontWeight: 'bold' }}>{recom[1].unit[n]}</span></p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {showPrecio &&
              <div className="RecomPrice" style={{ display: 'block' }}>
                <span style={{ height: '40px', display: 'inline-block', padding: '7px 0px', fontFamily: 'OpenSans', fontWeight: '600', fontSize: '14px' }}><p style={{ marginBottom: '10px' }}>Valor Subtotal</p></span>
                <div style={{ backgroundColor: '#ffffff'}}>
                  <div style={{ display: 'flex' }}>
                    {(recom[1].price).map((price, p) => 
                      <div key={p} style={{ margin: '10px auto' }}>
                        <p>$ {numeral(Math.ceil(price * recom[1].num[p] * data.bajo_hect)).format('0,0')}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            }
            {showPrecio &&
              <div className="RecomPriceTotal" style={{ display: 'block' }}>
                <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{ marginBottom: '10px' }}>Valor Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div style={{ width: '100%'}}>
                    <div>
                      <p>$ {numeral(Math.ceil(precioTotal(recom))).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  render() {
    const
      { cultivo, is_diff, recom, servicio } = this.props,
      prePilotos = ['agave', 'banano', 'pina', 'cana']
    ;
    
    if (recom && recom.length > 0) {
      return (
        <div style={{ margin: '0px auto' }}>
          { is_diff && prePilotos.includes(cultivo)
              && this.render_cuadro_diff() }
          { is_diff && !prePilotos.includes(cultivo)
              && this.render_cuadro_diff_escalas() }
          { !is_diff
              && servicio !== 'soilcheck'
              && prePilotos.includes(cultivo)
              && this.render_cuadro()      }
          { !is_diff
              && servicio !== 'soilcheck'
              && !prePilotos.includes(cultivo)
              && this.render_cuadro_escalas() }
          { !is_diff
              && servicio === 'soilcheck' 
              && this.render_cuadro_soil() }
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/TablaOportCuadro.jsx